export default "__VITE_ASSET__BzS4Jo3l__"